<template>
  <div class="layout">
    <m-assembly-table :total="total"
        :loading="loading"
        :formData="formData"
        :columns="columns"
        :settings="settings"
        :data="tableData"
        @onSubmit="onSubmit"
        @onPageSizeChange="onPageSizeChange"
        @onCurrentPageChange="onCurrentPageChange"
        @onSelectionChange="onSelectionChange"
        ref="table1">
        <div slot="tableHeader">
            <div style="overflow:hidden;">
                <div style="float:left;">
                    <Button type="primary" style="margin-left:10px;" :disabled="selection.length === 0" :loading="loading" @click="confirmed">
                        <!-- 确认 -->
                        {{$t('groupStop.t1')}}
                    </Button>
                    <a id="anchor1" style="margin-left:10px;">
                    <Button type="primary" :disabled="tableData.length === 0" :loading="loading" @click="exportExcel">
                        <!-- 导出 -->
                        {{$t('groupStop.t2')}}
                    </Button>
                    </a>
                </div>
                <div style="float:right;padding-right:10px;display:flex; align-items:center;">
                <Icon type="ios-circle-filled" size="27" color="#666666" style="margin-right:10px;"></Icon>
                <span style="margin-right:30px;">
                    <!-- 未确认 -->
                    {{$t('groupStop.t3')}}
                </span>
                <Icon type="ios-circle-filled" size="27" color="#009DD9" style="margin-right:10px;"></Icon>
                <span style="margin-right:30px;">
                    <!-- 已确认 -->
                    {{$t('groupStop.t4')}}
                </span>
                </div>
            </div>
        </div>
    </m-assembly-table>
  </div>
</template>
<script>
import mAssemblyTable from "@/components/awesome/page/assembly_table/index.js";
import axios from 'axios';
import moment from 'moment';
// import ExcellentExport from 'excellentexport';
export default {
    name: 'groupStop',
    components: {
        mAssemblyTable
    },
    data () {
        return {
            total: 0,
            loading: false,
            formData: {
                row: 2,
                items: [
                {
                    value: '',
                    field: 'SRM_ORG_ID',
                    layout: {
                    span: 8,
                    row: 1
                    },
                    options: {
                    multiple: false,
                    values: []
                    },
                    validators: {
                    required: {
                        required: true,
                        message: this.$t("groupStop.t5") // '事业部不能为空'
                    }
                    },
                    type: 'select',
                    title: this.$t("HSInspectManageMat.t41"), // '事业部'
                },
                {
                    value: '',
                    field: 'ITEM_CODE',
                    layout: {
                    span: 8,
                    row: 1
                    },
                    options: {
                    rows: 1
                    },
                    type: 'text',
                    title: this.$t("groupStop.t6") // '物料编码'
                },
                {
                    value: '',
                    field: 'INVALID_DATE_BEGIN',
                    layout: {
                        row: 1,
                        span: 8,
                        offset: 0
                    },
                    options: {
                        type: 'date',
                        format: 'yyyy-MM-dd'
                    },
                    style: 'width:100%',
                    type: 'datePicker',
                    title: this.$t("groupStop.t7"), // '停用时间',
                    placeholder: '',
                    isDouble: true,
                    validators: {
                        required: {
                            required: true,
                            message: this.$t("groupStop.t8") // '停用时间不能为空'
                        }
                    }
                },
                {
                    hide: true,
                    value: '',
                    field: 'INVALID_DATE_END',
                    layout: {
                        span: 8,
                        offset: 0,
                        row: 1
                    },
                    options: {
                        type: 'date',
                        format: 'yyyy-MM-dd',
                        options: {
                            disabledDate(date) {
                            }
                        }
                    },
                    style: 'width:100%',
                    type: 'datePicker',
                    title: '',
                    validators: {
                        required: {
                            required: true,
                            message: this.$t("groupStop.t8"), // '停用时间不能为空'
                        }
                    }
                },
                {
                    value: 'Unprocessed',
                    field: 'STATUS',
                    layout: {
                        span: 8,
                        row: 2
                    },
                    options: {
                        multiple: false,
                        values: [
                        {
                            label: this.$t("groupStop.t3"), // '未确认',
                            value: 'Unprocessed'
                        },
                        {
                            label: this.$t("groupStop.t4"), // '已确认',
                            value: 'Confirmed'
                        }
                        ]
                    },
                    type: 'select',
                    title: this.$t("groupStop.t9") // '确定状态'
                },
                {
                    value: '',
                    field: 'BATCH_INFO',
                    layout: {
                    span: 8,
                    row: 2
                    },
                    options: {
                        rows: 1
                    },
                    type: 'text',
                    title: this.$t("groupStop.t10") // '批次号'
                }
                ]
            },
            columns: {
                columns: [
                    {
                        title: '选择',
                        type: 'selection',
                        width: 40,
                        align: 'center'
                    },
                    {
                        title: this.$t("groupStop.t11"), // '状态',
                        minWidth: 50,
                        key: 'STATUS_TL',
                        align: 'center',
                        render: (h, params) => {
                            return h('Icon', {
                                props: {
                                    type: 'ios-circle-filled',
                                    size: 27,
                                    color: '#666666'
                                },
                                style: {
                                    cursor: params.row.STATUS_TL === '未处理' ? 'not-allowed' : 'pointer',
                                    color: params.row.STATUS_TL === '未处理' ? '#666666' : '#2d8cf0'
                                }
                            });
                        }
                    },
                    {
                        title: this.$t("HSInspectManageMat.t41"), // '事业部',
                        minWidth: 120,
                        key: 'INV_NAME'
                    },
                    {
                        title: this.$t("groupStop.t12"), // '组织',
                        minWidth: 220,
                        key: 'ORG_NAME',
                        render: (h, params) => {
                            let n = params.row.ORG_NAME.indexOf('_') + 1;
                            return h('div', {
                                style: {
                                    textAlign: 'left'
                                }
                            }, [
                                h('span', {
                                    style: {
                                    }
                                }, params.row.ORG_NAME.substr(n))
                            ]);
                        }
                    },
                    {
                        title: this.$t("groupStop.t13"), // '检验单号',
                        minWidth: 200,
                        key: 'SOURCE_EXAMINED_NO',
                        align: 'center'
                    },
                    {
                        title: this.$t("groupStop.t14"), // '供应商编码',
                        minWidth: 100,
                        key: 'SUP_CODE'
                    },
                    {
                        title: this.$t("groupStop.t6"), // '物料编码',
                        minWidth: 120,
                        key: 'ITEM_CODE'
                    },
                    {
                        title: this.$t("groupStop.t10"), // '批次号',
                        minWidth: 100,
                        key: 'BATCH_NO'
                    },
                    {
                        title: this.$t("groupStop.t7"), // '停用时间',
                        minWidth: 130,
                        key: 'INVALID_DATE_TL',
                        align: 'center'
                    }
                ]
            },
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true
            },
            tableData: [],
            page: 1,
            pageSize: 10,
            selection: [],
            mdmCode: ''
        };
    },
    methods: {
        queryVendorAndMdm() {
            axios.post('/gscint/vendor/queryVendorAndMdm', {
                vendorCode: this.vendorCode,
            }).then((res) => {
                this.mdmCode = res.data.data.datas.mdmCode;
            });
        },
        onSubmit (page, pageSize) {
            this.page = page;
            this.pageSize = pageSize;
            this.loading = true;
            let formData = this.getFormDataVModel(this.formData.items);
            axios.get('/qms2gsc/SingleBatchInvalid/GetListForeign', { // /qms2gsc/SingleBatchInvalid/GetList
                params: {
                    model: JSON.stringify(
                        {
                            PAGEINDEX: page,
                            PAGESIZE: pageSize,
                            ...formData,
                            SUPPLIER_CODE: this.mdmCode
                        }
                    )
                }
            })
            .then((res) => {
                this.selection = [];
                this.loading = false;
                let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
                let data = resp.MainResultData;
                if (data.DATA) {
                this.total = data.TOTAL;
                this.tableData = data.DATA;
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 页容量改变时触发
        onPageSizeChange(page, pageSize) {
            this.onSubmit(page, pageSize);
        },
        // 当前页改变时触发
        onCurrentPageChange(page, pageSize) {
            this.onSubmit(page, pageSize);
        },
        onSelectionChange (selection) {
            this.selection = selection;
        },
        getOrgList () {
            axios.get('/gscint/vendor/getOverSeaBuList', {
                params: {
                    SITE: 'Y',
                    ASL: 'N'
                }
            })
            .then((res) => {
                let orgList = res.data.data.datas;
                orgList.forEach((item) => {
                    item.label = item.buName;
                    item.value = item.qmsId;
                });
                this.getFormDataItemObj(this.formData.items, 'SRM_ORG_ID').options.values = orgList;
            });
        },
        showErrorTips (key = 'loading') {
            this[key] = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
            });
        },
        // 确认
        confirmed () {
            let ids = [];
            this.selection.map((item) => {
                if (item.STATUS_TL === '未处理') {
                    ids.push(item.ID);
                }
            });
            if (ids.length === 0) {
                this.$Modal.error({
                    title: this.$t('HSInspectManageMat.t48'),
                    content: this.$t("groupStop.t15") // '请勾选状态为“未处理”的数据！'
                });
                return false;
            }
            this.loading = true;
            axios.get('/qms2gsc/SingleBatchInvalid/Confirmed', {
                params: {
                    ID: ids.join()
                }
            })
            .then((res) => {
                this.loading = false;
                let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
                if (resp.IsSucess) {
                    this.onSubmit(this.page, this.pageSize);
                    this.$Modal.success({
                        title: this.$t('HSInspectManageMat.t48'),
                        content: this.$t("groupStop.t16") // '确认成功！'
                    });
                } else {
                    this.$Modal.error({
                        title: this.$t('HSInspectManageMat.t48'),
                        content: resp.ErrorMessage
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 导出
        exportExcel () {
            this.loading = true;
            let excelName = this.$t('HSInspectManageMat.t17'); // '供方单批次停用';
            let excelColumns = this.columns.columns;
            let id = 'anchor1';
            let tableData = this.tableData;
            const options = {
                anchor: id,
                filename: excelName,
                format: 'xlsx'
            };
            let columns = [];
            excelColumns.map((item) => {
                if (item.title && item.title !== '选择') {
                    columns.push(item.title);
                }
            });
            let datas = [];
            tableData.map((item, key) => {
                datas.push([]);
                excelColumns.map((item2) => {
                    if (item2.title && item2.title !== '选择') {
                        datas[key].push(item[item2.key]);
                    }
                });
            });
            const sheets = [
                {
                    name: excelName,
                    from: {
                        array: [
                            columns,
                            ...datas
                        ]
                    }
                }
            ];
            console.log('sheets', sheets);
            // ExcellentExport.convert(options, sheets);
            setTimeout(() => {
                this.loading = false;
            }, 3000);
        }
    },
    mounted () {
        this.queryVendorAndMdm();
        this.getOrgList();
        this.getFormDataItemObj(this.formData.items, 'INVALID_DATE_BEGIN').value = moment().subtract(3, 'months');
        this.getFormDataItemObj(this.formData.items, 'INVALID_DATE_END').value = moment();
    }
};
</script>
<style lang="less" scoped>
.layout {
  background: #FFF;
}
</style>